import type { TaskFeedLink, TaskFeedStatus } from '@peles/shared';
import { apiClient } from './client';

/** `/task-feed` — the signed-in person's task calendar feed. */
const BASE = '/task-feed';

export async function getTaskFeed(): Promise<TaskFeedStatus> {
  const { data } = await apiClient.get<TaskFeedStatus>(BASE);
  return data;
}

/** A new address — shown once; any earlier one stops working. */
export async function createTaskFeed(): Promise<TaskFeedLink> {
  const { data } = await apiClient.post<TaskFeedLink>(BASE);
  return data;
}

export async function deleteTaskFeed(): Promise<void> {
  await apiClient.delete(BASE);
}
